<crm-auto-complete
  #dealAutoComplete
  [(value)]="selectedDeal"
  (valueChange)="selectedDealChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="deals"
  [virtualScroll]="true"
  [virtualScrollItemSize]="88"
  [inputStyleClass]="inputStyleClass"
  [panelStyleClass]="panelStyleClass"
  [scrollHeight]="scrollHeight"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [isError]="isError"
  [loading]="loading"
  (completeMethod)="customSearch ? dealSearch.emit($event.query) : searchDeal($event.query)">
  <ng-template
    let-deal="item"
    #itemTemplate>
    <ng-container *ngIf="toDeal(deal) as deal">
      <div class="crm-deal-autocomplete-item w-full flex justify-content-between align-items-start gap-3">
        <div class="crm-deal-autocomplete-item__body flex-1 min-w-0">
          <p
            *ngIf="deal.name?.length > 40; else shortNameTemplate"
            class="font-medium text-black m-0"
            [pTooltip]="deal.name"
            tooltipPosition="top">
            <span [innerHTML]="highlightMatchText(deal.name) | safeHtml"></span>
          </p>
          <p class="font-medium text-gray-500 m-0 mt-1">{{ deal.contragent?.name }}</p>
          <p class="font-bold text-green-500 m-0 mt-1">{{ deal.amount | number: '.0-0' }}</p>
        </div>
        <div
          *ngIf="deal.status"
          class="crm-deal-autocomplete-item__status flex-shrink-0 white-space-nowrap">
          <crm-status-label
            [name]="deal.status.name"
            [color]="deal.status.color"></crm-status-label>
        </div>
      </div>

      <ng-template #shortNameTemplate>
        <p class="font-medium text-black m-0">
          <span [innerHTML]="highlightMatchText(deal.name) | safeHtml"></span>
        </p>
      </ng-template>
    </ng-container>
  </ng-template>
</crm-auto-complete>
